import {Button, Col, Divider, Row, Space, Table, Typography} from "antd";

import {HeaderPrintForm, Sign} from "components/common/PrintForm";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppSelector} from "redux/hooks";
import {columns as columnsInit} from "./config";
import {
  formatDateToString,
  formatToCurrencyTypeToFixed,
  isValuable,
} from "helper/common";
import {CURRENCY_LOCALE, FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import moment from "moment";
import "./ReceiptModal.scss";
import Descriptions from "components/common/DescriptionsCustom/DescriptionsCustom";
import DescriptionsItem from "components/common/DescriptionsCustom/DescriptionsItemCustom";

const ReceiptShoppingtModal = props => {
  const {closeModal} = props;
  const printRef = useRef<any>();

  const {detailProposeShopping} = useAppSelector(
    state => state.proposeShopping
  );

  const [dataTable, setDataTable] = useState<any[]>([]);
  const fieldsInit: any[] = [
    {label: "Tên đề nghị"},
    {label: "Nội dung"},
    {label: "Người đề nghị"},
    {
      label: "Bộ phận",
    },
    {
      label: "Nhà cung cấp",
    },
    {
      label: "Địa điểm",
    },
    {
      label: "Thời gian",
    },
  ];

  const [fields, setFields] = useState<any>(fieldsInit);
  const [columns, setColumns] = useState<any>(columnsInit);

  useEffect(() => {
    if (detailProposeShopping) {
      setDataTable(detailProposeShopping?.chiTietPhieuDeNghiMuaSamDtos);
      const setValueDescription = () => {
        fields.find(e => e?.label == "Tên đề nghị").value =
          detailProposeShopping?.tenDeNghi;
        fields.find(e => e?.label == "Nội dung").value =
          detailProposeShopping?.moTa;
        fields.find(e => e?.label == "Người đề nghị").value =
          detailProposeShopping?.nguoiDeNghi;
        fields.find(e => e?.label == "Bộ phận").value =
          detailProposeShopping?.boPhan;
        fields.find(e => e?.label == "Nhà cung cấp").value =
          detailProposeShopping?.nhaCungCap;
        fields.find(e => e?.label == "Địa điểm").value =
          detailProposeShopping?.diaDiem;
        fields.find(e => e?.label == "Thời gian").value = formatDateToString(
          moment(detailProposeShopping?.timeLine),
          FORMAT_TIME.dayFull
        );
        setFields(fields);
      };
      setValueDescription();
    }
  }, [detailProposeShopping]);

  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="print-form store-receipt">
      <div ref={printRef} className="">
        <table>
          <thead>
            <tr style={{height: "20mm"}}></tr>
          </thead>
          <tbody>
            <HeaderPrintForm></HeaderPrintForm>
            <div>
              <div style={{marginBottom: 8}}>
                <Row justify={"center"}>
                  <Typography.Title
                    style={{
                      fontWeight: "700",
                      fontSize: 30,
                    }}
                  >
                    PHIẾU ĐỀ NGHỊ MUA SẮM
                  </Typography.Title>
                </Row>
                <div>
                  <Descriptions
                    size="small"
                    // column={{xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 6}}
                  >
                    {/* <Row wrap={true} style={{width: "100%"}}> */}
                    {fields &&
                      fields
                        .filter(e => e?.hidden != true)
                        .map(e => (
                          // <Col span={12}>
                          <DescriptionsItem label={e.label} span={e?.span}>
                            {e?.value ?? "--"}
                          </DescriptionsItem>
                          // </Col>
                        ))}
                    {/* </Row> */}
                  </Descriptions>
                </div>
              </div>
              {dataTable.length > 0 && (
                <div className="container2">
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 20,
                        marginBottom: 8,
                      }}
                    >
                      Chi phí dự kiến
                    </Typography.Text>
                  </Row>

                  <Table
                    className="table-print"
                    columns={columns}
                    dataSource={dataTable}
                    pagination={false}
                    bordered
                  ></Table>
                </div>
              )}
              <Row justify={"end"} style={{marginTop: 12}}>
                <div className="container-value" style={{textAlign: "end"}}>
                  <span style={{fontWeight: 600}}>Tổng giá trị: </span>
                  {detailProposeShopping && (
                    <span>
                      {formatToCurrencyTypeToFixed(
                        detailProposeShopping?.tongTien,
                        2
                      )}
                      đ
                    </span>
                  )}
                </div>
              </Row>
              <Row
                style={{
                  marginTop: 36,
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Sign
                  time={formatDateToString(detailProposeShopping?.createdDate)}
                  style={{marginTop: 0, width: "fit-content"}}
                  span={24}
                  label={"Người yêu cầu"}
                  nguoiThucHien={detailProposeShopping?.nguoiDeNghi ?? ""}
                ></Sign>{" "}
                <Sign
                  isRow={isValuable(detailProposeShopping?.ngayTBPDuyet)}
                  time={formatDateToString(detailProposeShopping?.ngayTBPDuyet)}
                  style={{marginTop: 0, width: "fit-content"}}
                  span={24}
                  label={"Trưởng bộ phận"}
                  nguoiThucHien={detailProposeShopping?.tbpduyet ?? ""}
                ></Sign>{" "}
                {/* </Space> */}
              </Row>
              <Row
                style={{
                  marginTop: 36,
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Sign
                  isRow={isValuable(detailProposeShopping?.ngayKSTCDuyet)}
                  time={formatDateToString(
                    detailProposeShopping?.ngayKSTCDuyet
                  )}
                  style={{marginTop: 0, width: "fit-content"}}
                  span={24}
                  label={"Kiểm soát tài chính"}
                  nguoiThucHien={detailProposeShopping?.kstcduyet ?? ""}
                ></Sign>{" "}
                <Sign
                  isRow={isValuable(detailProposeShopping?.ngayBGDDuyet)}
                  time={formatDateToString(detailProposeShopping?.ngayBGDDuyet)}
                  style={{marginTop: 0, width: "fit-content"}}
                  span={24}
                  justify="end"
                  label={"Ban giám đốc"}
                  nguoiThucHien={detailProposeShopping?.bgdduyet ?? ""}
                ></Sign>{" "}
                {/* </Space> */}
              </Row>
            </div>
          </tbody>
          <tfoot>
            <tr style={{height: "2cm"}}></tr>
          </tfoot>
        </table>
      </div>
      <Divider></Divider>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button
            danger
            onClick={() => {
              closeModal();
            }}
          >
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="print-form store-receipt"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};
export default ReceiptShoppingtModal;
